export default "__VITE_ASSET__COu05YUV__"